import React, { useState } from 'react';


export default function IssueVoucherForm({ customer, onIssue, busy, actor }) {
  const [hoursPurchased, setHoursPurchased] = useState(10);

  function handleSubmit(event) {
    event.preventDefault();
    onIssue({
      customerId: customer.id,
      phone: customer.phone,
      hoursPurchased: Number(hoursPurchased),
      performedByUserId: actor?.id || null,
      performedByName: actor?.name || actor?.email || 'Operador',
    });
  }

  return (
    <form onSubmit={handleSubmit} className="rounded-[24px] border border-[var(--app-border)] bg-[rgba(248,250,252,0.85)] p-5 space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-slate-700">Alta manual de bono</p>
        <span className="text-[11px] uppercase tracking-[0.2em] text-slate-400">Venta en tienda</span>
      </div>
      <div className="flex gap-3">
        <input
          type="number"
          min="1"
          step="1"
          value={hoursPurchased}
          onChange={(event) => setHoursPurchased(event.target.value)}
          className="app-input-compact w-32 rounded-2xl px-4 py-3 text-xl font-semibold"
        />
        <button
          type="submit"
          disabled={busy}
          className="flex-1 rounded-2xl bg-[#0a84ff] hover:bg-[#0077ed] text-white font-semibold py-3 disabled:opacity-50"
        >
          {busy ? 'Guardando...' : 'Crear bono'}
        </button>
      </div>
    </form>
  );
}
